module.exports = __webpack_public_path__ + "media/images/version_merge/iphone_back-83a9cb6b1e8be31f7bacd1e9e6c2ce99.png";